import React from 'react';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { compose } from '@beef/utils';
import { withAnalyticsOnBlockView } from "../hoc/withAnalyticsOnView";
import { FAQList } from "../../components/FAQList";
import { getAnalyticEventType } from "../../store/blocks/selectors";
import { templateParser } from "../../utils";
import { onFAQTabClickAnalytics } from "../../store/blocks/checkAddress/actions";
import { getFaqCategories, getFaqDataList, getFaqRegion, getFaqRegionin, getFaqTitle } from "../../store/blocks/faq/selectors";
import { FttbBlocks } from "../constants";
import { defineBlock } from "../utils";
var _FaqBlock = function _FaqBlock(_ref) {
  var categories = _ref.categories,
    className = _ref.className,
    items = _ref.items,
    onClick = _ref.onClick,
    title = _ref.title;
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    "data-t-id": "blocks-FaqBlock"
  }, /*#__PURE__*/React.createElement(FAQList, {
    categories: categories,
    items: items,
    onClick: onClick,
    title: title
  }));
};
var mapStateToProps = function mapStateToProps(state) {
  var _getFaqDataList;
  var blockTitle = templateParser(getFaqTitle(state), {
    region: getFaqRegion(state),
    regionin: getFaqRegionin(state)
  });
  return {
    analyticBlockTitle: blockTitle,
    categories: getFaqCategories(state),
    items: getFaqDataList(state),
    pageType: getAnalyticEventType(state),
    region: getFaqRegion(state),
    regionin: getFaqRegionin(state),
    shouldRender: !!((_getFaqDataList = getFaqDataList(state)) !== null && _getFaqDataList !== void 0 && _getFaqDataList.length),
    title: blockTitle
  };
};
var mapDispatchToProps = {
  onClick: onFAQTabClickAnalytics
};
var _FaqBlockHOC = withAnalyticsOnBlockView(_FaqBlock);
export var FaqBlock = compose(defineBlock(FttbBlocks.FAQ), connect(mapStateToProps, mapDispatchToProps), withRenderFlag)(_FaqBlockHOC);